export default __webpack_public_path__ + "img/open-chat-white.2bc0e238.svg";